import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-6xl md:text-7xl font-serif font-bold text-[#3D2817] mb-6">
            Visit Us
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light">
            We'd love to see you at The Bridge Street Café
          </p>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-16 px-6 bg-[#F5F3F0]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            {/* Left Content */}
            <div className="lg:col-span-2 space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#C17855] text-white rounded-full mb-6">
                  <i className="ri-map-pin-line text-lg"></i>
                  <span className="text-sm font-medium">Find Us</span>
                </div>
                
                <h2 className="text-4xl font-serif font-bold text-[#3D2817] mb-6">
                  Visit Us in Otley
                </h2>
                
                <div className="space-y-3 mb-8">
                  <p className="text-lg text-gray-700 font-medium">The Bridge Street Café</p>
                  <p className="text-gray-600">Bridge Street</p>
                  <p className="text-gray-600">Otley, West Yorkshire</p>
                  <p className="text-gray-600">LS21 1BQ</p>
                </div>
                
                <p className="text-gray-600 leading-relaxed mb-8">
                  Located in the heart of Otley, welcoming customers from the surrounding area. Easy parking nearby and accessible by local bus routes.
                </p>
              </div>
              
              {/* Opening Hours */}
              <div>
                <h3 className="text-2xl font-bold text-[#3D2817] mb-4 flex items-center gap-3">
                  <i className="ri-time-line text-[#C17855]"></i>
                  Opening Hours
                </h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-gray-300">
                    <span className="font-bold text-[#3D2817]">Monday - Friday</span>
                    <span className="text-gray-700">8:00am - 5:00pm</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-gray-300">
                    <span className="font-bold text-[#3D2817]">Saturday</span>
                    <span className="text-gray-700">8:00am - 5:00pm</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-gray-300">
                    <span className="font-bold text-[#3D2817]">Sunday</span>
                    <span className="text-gray-700">9:00am - 4:00pm</span>
                  </div>
                </div>
              </div>
              
              {/* Contact Button */}
              <div>
                <a 
                  href="tel:01943000000" 
                  className="inline-flex items-center gap-3 px-8 py-4 border-2 border-[#C17855] text-[#C17855] rounded-full font-medium hover:bg-[#C17855] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Call Us: 01943 000 000
                </a>
              </div>
            </div>
            
            {/* Right Map */}
            <div className="lg:col-span-3">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white" style={{ height: '650px' }}>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2348.3333333333335!2d-1.6892!3d53.9046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTPCsDU0JzE2LjYiTiAxwrA0MScyMS4xIlc!5e0!3m2!1sen!2suk!4v1234567890123!5m2!1sen!2suk"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="The Bridge Street Café Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Info Cards */}
      <section className="py-16 px-6 bg-[#FAF7F2]">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-[#C4D4C0] rounded-full mb-6">
                <i className="ri-parking-box-line text-[#3D2817] text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#3D2817] mb-3">Parking</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Convenient street parking and public car parks within walking distance
              </p>
            </div>
            
            <div className="bg-white rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-[#F4D4C8] rounded-full mb-6">
                <i className="ri-bus-line text-[#3D2817] text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#3D2817] mb-3">Public Transport</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Regular bus services stop nearby, connecting to Leeds and surrounding areas
              </p>
            </div>
            
            <div className="bg-white rounded-3xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-[#C17855]/20 rounded-full mb-6">
                <i className="ri-wheelchair-line text-[#3D2817] text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#3D2817] mb-3">Accessibility</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Wheelchair accessible entrance and facilities available
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Get in Touch Section */}
      <section className="py-16 px-6 bg-[#F5F3F0]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-[#3D2817] mb-6">Get in Touch</h2>
          <p className="text-xl text-gray-600 mb-10 leading-relaxed">
            Have a question or want to book a table for a group? We'd love to hear from you.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <a 
              href="tel:01943000000" 
              className="flex items-center justify-center gap-3 px-8 py-5 bg-[#C17855] text-white rounded-full font-medium hover:bg-[#A66545] transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-phone-line text-xl"></i>
              Call Us
            </a>
            
            <a 
              href="mailto:hello@bridgestreetcafe.co.uk" 
              className="flex items-center justify-center gap-3 px-8 py-5 bg-white text-[#C17855] border-2 border-[#C17855] rounded-full font-medium hover:bg-[#C17855] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-xl"></i>
              Email Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}